import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { filter } from 'rxjs/operators';

import { AnalyticsService } from 'src/app/service/analytics/analytics.service';
import { stripQuery } from 'src/app/util/pii-scrub.util';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'portal-ui';

  constructor(private router: Router,
              private analytics: AnalyticsService) { }

  ngOnInit(): void {
    // Mixpanel: one Page Viewed event per navigation (NEWTON-483). Subscribed
    // exactly once here to avoid duplicate firing. Query strings are stripped
    // so tokens/emails never leave the browser.
    this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe(event => {
          const path = stripQuery((event as NavigationEnd).urlAfterRedirects);
          this.analytics.track('Page Viewed', { path });
        });
  }
}
